<template>
  <div v-frag>
    <b-row>
      <b-colxx xxs="12">
        <piaf-breadcrumb :heading="$t('menu.create')" />
        <div class="separator mb-5"></div>
      </b-colxx>
    </b-row>

    <div v-if="isLoading" class="loading-overlay">
      <div class="loading"></div>
    </div>
    <b-row>
      <b-colxx xxs="12">
        <b-card class="mb-4">
          <b-form @submit.prevent="onSubmit" class="av-tooltip">
            <b-form-group :label="$t('pages.pages.selectImage')">
              <b-form-file v-model="createForm.image" accept="image/*"></b-form-file>
            </b-form-group>

            <b-form-group :label="`${$t('pages.pages.title')} (EN)`">
              <b-form-input
                type="text"
                v-model="$v.createForm.title_en.$model"
                :state="!$v.createForm.title_en.$error"
              />
              <b-form-invalid-feedback v-if="!$v.createForm.title_en.required">
                {{ $t('formErrors.enterTitle') }}
              </b-form-invalid-feedback>
            </b-form-group>

            <b-form-group :label="`${$t('pages.pages.title')} (RU)`">
              <b-form-input
                type="text"
                v-model="$v.createForm.title_ru.$model"
                :state="!$v.createForm.title_ru.$error"
              />
              <b-form-invalid-feedback v-if="!$v.createForm.title_ru.required">
                {{ $t('formErrors.enterTitle') }}
              </b-form-invalid-feedback>
            </b-form-group>

            <b-form-group :label="`${$t('pages.pages.content')} (EN)`">
              <editor
                api-key="3j0ilbli3cyi4ni7rl6bja496o1axgmnbofy3zc9fdbbm8i2"
                v-model="createForm.content_en"
                :disabled="false"
                :init="{
                  height: 400,
                  menubar: true,
                  plugins: [
                    'advlist autolink lists code table link image charmap print preview anchor',
                    'searchreplace visualblocks code fullscreen',
                    'insertdatetime media table paste code help wordcount'
                  ],
                  toolbar:
                    'undo redo | code | table | formatselect | bold italic backcolor | \
                           alignleft aligncenter alignright alignjustify | \
                           bullist numlist outdent indent | removeformat'
                }"
              />
            </b-form-group>

            <b-form-group :label="`${$t('pages.pages.content')} (RU)`">
              <editor
                api-key="3j0ilbli3cyi4ni7rl6bja496o1axgmnbofy3zc9fdbbm8i2"
                v-model="createForm.content_ru"
                :disabled="false"
                :init="{
                  height: 400,
                  menubar: true,
                  plugins: [
                    'advlist autolink lists code table link image charmap print preview anchor',
                    'searchreplace visualblocks code fullscreen',
                    'insertdatetime media table paste code help wordcount'
                  ],
                  toolbar:
                    'undo redo | code | table | formatselect | bold italic backcolor | \
                           alignleft aligncenter alignright alignjustify | \
                           bullist numlist outdent indent | removeformat'
                }"
              />
            </b-form-group>

            <b-button type="submit" variant="primary" class="mt-2">
              {{ $t('buttons.save') }}
            </b-button>
          </b-form>
        </b-card>
      </b-colxx>
    </b-row>
  </div>
</template>

<script>
import Editor from '@tinymce/tinymce-vue'
const { required } = require('vuelidate/lib/validators')

export default {
  components: {
    editor: Editor
  },
  data: () => ({
    isLoading: true,
    createForm: {
      title_en: '',
      title_ru: '',
      content_en: '',
      content_ru: '',
      image: null
    }
  }),
  validations: {
    createForm: {
      title_en: { required },
      title_ru: { required }
    }
  },
  mounted() {
    this.handlePageLoading()
  },
  beforeDestroy() {
    this.clearForm()
  },
  methods: {
    handlePageLoading() {
      setTimeout(() => {
        this.isLoading = false
      }, 1500)
    },
    addNotification(type, title, message) {
      this.$notify(type, title, message, { duration: 2000, permanent: false })
    },
    onSubmit() {
      this.$v.$touch()
      if (!this.$v.$invalid) {
        this.$store.dispatch('pages/createSinglePage', {
          payload: this.createForm,
          vm: this
        })
      }
    },
    clearForm() {
      this.createForm.title_en = ''
      this.createForm.title_ru = ''
      this.createForm.content_en = ''
      this.createForm.content_ru = ''
    }
  }
}
</script>
